module.exports = __webpack_public_path__ + "static/media/password-reset.a3632e92.svg";